























import Vue, { PropType } from 'vue'

export default Vue.extend({
  name: 'MobileSectionMenu',
  props: {
    headers: {
      type: Array,
    },
    active: {
      type: Number,
    },
  },
  data: () => ({}),
})
